<footer>
    <a (click)="redirectToMain()">Podcast</a>
    <a (click)="redirectToAboutUs()">Über uns</a>
    <a (click)="redirectToContact()">Kontakt</a>
    <!-- <a href="">Impressum</a>
    <a href="">Datenschutzerklärung</a> -->
</footer>
